var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function getFormInputParams(form) {
  var e_1, _a;
  var formInputParams = {};
  var elements = form.current && form.current.elements;
  if (elements) {
    try {
      for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var element = elements_1_1.value;
        if (element.nodeName === 'INPUT') {
          var el = element;
          if (!el.name) continue;
          var type = el.type && el.type.toLocaleLowerCase();
          switch (type) {
            case 'checkbox':
              formInputParams[el.name] = el.checked;
              break;
            case 'text':
              formInputParams[el.name] = el.value;
              break;
            case 'radio':
              if (el.checked) {
                formInputParams[el.name] = el.value;
              }
              break;
            default:
              if (el.value) {
                formInputParams[el.name] = el.value;
              }
          }
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  return formInputParams || {};
}